import { sessionState } from 'src/app/core/services/signal-state.storage';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import {
  Ca_State_prov,
  Us_State_prov,
} from 'src/app/gdo/gdo-shared/Models/Constants';
import { IAcctDetail } from 'src/app/gdo/gdo-shared/Models/Interfaces';
import { GdoInfoPopupDialogComponent } from 'src/app/gdo/gdo-shared/gdo-shared-components/gdo-info-popup-dialog/gdo-info-popup-dialog.component';

@Component({
    selector: 'app-gdo-vehicle-detail',
    templateUrl: './gdo-vehicle-detail.component.html',
    styleUrls: ['./gdo-vehicle-detail.component.scss'],
    standalone: false
})
export class GdoVehicleDetailComponent implements OnInit {
  stolenStatus: boolean = false;
  stolenStatusRequested: boolean = false;
  VIN = '19UYA31581D000034'; // NOTE: Test VIN for now ;

  planType = 'loading';
  planStatus = 'planAvailable';
  termsAndCondition: any;
  termsAndConditionStatus: any;
  userName = 'NA';
  vehicleMake = 'Honda';

  acctDetail!: IAcctDetail;

  ariaAcctDetail: any;
  selectedMP: any;
  selectedSP: any;
  modelYear: any = '';
  trim: any = '';
  model: any = '';
  nickName: any = null;
  licensePlateNo: any = null;
  aliasName: any = null;

  constructor(private dialog: MatDialog, private appService: AppService,private router: Router) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };
  }

  ngOnInit(): void {
    sessionState.removeItem("subscriptionTypeGdo")
    this.VIN = this.appService.getVIN() ?? this.VIN;
    this.getAccountContract();
    this.getReportStolenStatus();
    this.getTermsAndConditionsContent();
    // this.getTermsAndConditionsStatus();
    this.getVehicleDetails();
    this.userName = sessionState.getItem('first_name') ?? 'NA';
  }

  getAccountContract() {
    this.appService.AcctContracts().subscribe((res) => {
      if (res && res.status === 'success') {
        this.planStatus = 'available';
        this.acctDetail = res.responseBody.acctDetail;
        this.acctDetail.completeConstrunctedAddress = this.constructAddress(this.acctDetail);

        this.appService.setAccDetails(this.acctDetail);

        let selectedMp: any;

        let masterPlanInfo = res.responseBody.acctDetail.masterPlansInfo;

        for (const iterator of masterPlanInfo) {

          if (iterator.clientMasterPlanId === 'Connected_Products_US') {
            // let gdoVin = iterator.mpPlanInstFields.find((x) => x.planInstanceFieldName === 'VIN');
            // this.VIN = gdoVin.planInstanceFieldValue;
            // sessionState.setItem('currentVinLocal', this.VIN);
            selectedMp = iterator;
            sessionState.setItem("subscriptionTypeGdo", "gdo");
          }
          // if (iterator.mpPlanInstFields) {
          //   const gdoMp = iterator.mpPlanInstFields.find((x) => x.planInstanceFieldName === 'subscriptionType')
          //   if (gdoMp) {
          //     for (const mp_iterator of iterator.mpPlanInstFields) {
          //       if (mp_iterator.planInstanceFieldName === 'VIN' && mp_iterator.planInstanceFieldValue === this.VIN) {
          //         selectedMp = iterator;
          //       } if (mp_iterator.planInstanceFieldName === 'subscriptionType' && mp_iterator.planInstanceFieldValue === "gdo") {
          //         // this.subscriptionTypeGdo = true;
          //         sessionState.setItem("subscriptionTypeGdo", "gdo")
          //       }
          //     }
          //   }
          // }
          if (selectedMp) break;
        }
        
        
        if (selectedMp) {
          this.selectedMP = selectedMp;
          this.appService.setSelectedMp(this.selectedMP);
          this.appService.setVehicleData(this.selectedMP);


          // this.appService.MyVehicle().subscribe((res) => {
          //   if (res && (res.status == 'SUCCESS' || res.status == 'success')) {
          //     let vehicleInfo = res.vehicleInfo;
          //     if (vehicleInfo && vehicleInfo.length > 0) {
          //       this.modelYear = vehicleInfo[0].ModelYear;
          //       this.model = vehicleInfo[0].ModelCode;
          //       this.trim = vehicleInfo[0].ModelTrimTypeCode;
          //       this.aliasName = vehicleInfo[0]['Alias Name'];
          //       this.nickName = this.aliasName;
          //     }
          //   }
          // });

          this.getPlanType();
          this.appService.setIsDataAvailable(true);
        } else {
          this.planType = 'noPlanAvailable';
          this.planStatus = 'notAvailable';
          this.appService.setIsDataAvailable(false);
        }
      }
      
    },
      (err) => {
        
        
        
        let ref = this.dialog.open(GdoInfoPopupDialogComponent, {
          width: '27vw',
          // height: '30vh',
          data: {
            title: 'Error',
            infoMsg: err && err.error && err.error.errorResponse && err.error.errorResponse.responseBody.error.errorMsg ? err.error.errorResponse.responseBody.error.errorMsg : 'There seems to be some issue, please try again!',
            btnText: 'Close',
          },

        });
        this.planType = 'noPlanAvailable';
        this.planStatus = 'notAvailable';
        this.appService.setIsDataAvailable(false);
      }
    );
  }

  getReportStolenStatus() {
    this.appService.GetReportStolenStatus(null).subscribe((res) => {
      if (res && res.status === 'success') {
        let responseBody = res.responseBody;
        if (
          responseBody &&
          responseBody.caseInfo &&
          responseBody.caseInfo.status &&
          responseBody.caseInfo.status !== '' &&
          responseBody.caseInfo.status !== 'Closed' &&
          responseBody.caseInfo.status !== 'Resolved' &&
          responseBody.caseInfo.status !== 'New'
        ) {
          this.stolenStatus = true;
        } else if (
          responseBody &&
          responseBody.caseInfo &&
          responseBody.caseInfo.status &&
          responseBody.caseInfo.status == 'New'
        ) {
          this.stolenStatus = false;
          this.stolenStatusRequested = true;
        }
      }
    });
  }

  getTermsAndConditionsContent() {
    this.appService.TcContent(null).subscribe((res) => {
      if (res) {
        const document = new DOMParser().parseFromString(res, 'application/xml');
        var elements = document.getElementsByTagName('content');
        if (elements && elements.length > 0) {
          this.termsAndCondition = elements[0].textContent;
        }
      }
    });
  }

  getTermsAndConditionsStatus() {
    this.appService.TcStatus(null).subscribe((res) => {
      if (res) {
        const document = new DOMParser().parseFromString(res, 'application/xml');
        var elements = document.getElementsByTagName('acceptStatus');
        if (elements && elements.length > 0) {
          this.termsAndConditionStatus = elements[0].textContent;
        }
      }
    });
  }

  getPlanType() {
    if (this.isSuppPlanActive()) {
      this.planType = 'planAvailable';
    }
    else if (this.isSuppPlanCancelled()) {
      this.planType = 'planAvailable';
    }
    else {
      this.planType = 'noPlanAvailable';
    }
  }

  isSuppPlanActive() {
    let suppPlansList = this.selectedMP.suppPlansInfo;
    // 
    if (suppPlansList && suppPlansList.length > 0) {
      for (const supp_plan_iterator of suppPlansList) {
        if (supp_plan_iterator.suppPlanInstanceStatus === 'Active') {
          this.selectedSP = supp_plan_iterator;
          this.appService.setSelectedSp(this.selectedSP);
          
          
          return true;
        }
      }
      this.selectedSP = suppPlansList[suppPlansList.length - 1];
      this.appService.setSelectedSp(this.selectedSP);
      return false;
    } else {
      this.selectedSP = null;
      return false;
    }
  }
  // for when we dont have a active supPlan
  isSuppPlanCancelled() {
    let suppPlansList = this.selectedMP.suppPlansInfo;
    // 
    if (suppPlansList && suppPlansList.length > 0) {
      
      // select the latest cancelled one
      this.selectedSP = suppPlansList[suppPlansList.length - 1];
      
      this.appService.setSelectedSp(this.selectedSP);
      return true;
    }

    else {
      this.selectedSP = null;
      return false;
    }
  }

  isTrialSuppPlanActive() {
    let suppPlansList = this.selectedMP.suppPlansInfo;
    if (suppPlansList && suppPlansList.length > 0) {
      for (const supp_plan_iterator of suppPlansList) {
        let arrayRateSchedule =
          supp_plan_iterator?.clientAltRateScheduleId.split('_');
        let planName;
        if (arrayRateSchedule) {
          let arrLen = arrayRateSchedule?.length;
          if (arrLen) {
            planName = arrayRateSchedule[arrLen - 1].toLowerCase();
          }
        }
        if (
          planName &&
          planName === 'trial' &&
          supp_plan_iterator.suppPlanInstanceStatus === 'Active'
        ) {
          this.selectedSP = supp_plan_iterator;
          return true;
        }
      }
      this.selectedSP = suppPlansList[suppPlansList.length - 1];
      return false;
    } else {
      this.selectedSP = null;
      return false;
    }
  }

  constructAddress(data: any) {
    let constructAddress = data.address1 ? data.address1 : '';
    constructAddress = data.address2
      ? constructAddress + ' ' + data.address2
      : constructAddress;
    constructAddress = data.city
      ? constructAddress + ' ' + data.city
      : constructAddress;
    let country = '';
    let stateProv = '';

    if (data.countryCode) {
      if (data.stateProv && data.countryCode === 'US') {
        const result = Us_State_prov.filter((item) => {
          return item.value === data.stateProv;
        });
        if (result && result.length > 0) {
          stateProv = result[0].displayValue;
        }
        country = 'United States';
      } else if (data.stateProv && data.countryCode === 'CA') {
        const result = Ca_State_prov.filter((item) => {
          return item.value === data.stateProv;
        });
        if (result && result.length > 0) {
          stateProv = result[0].displayValue;
        }
        country = 'Canada';
      } else if (data.stateProv && data.countryCode === 'GB') {
        country = 'United Kingdom';
      }
    }

    constructAddress = constructAddress + ' ' + stateProv;
    constructAddress = constructAddress + ' ' + country;
    constructAddress = data.postal_cd
      ? constructAddress + ' ' + data.postal_cd
      : constructAddress;

    return constructAddress;
  }

  // onRemoveFromAccount(): void {
  //   let isAcura: boolean = false
  //   let vehicleData = this.appService.getVehicleData()
  //   if (vehicleData) {
  //     if (vehicleData.make == "Acura") {
  //       isAcura = true
  //     } else {
  //       isAcura = false
  //     }
  //   } else {
  //     if (this.vehicleMake == "Honda") {
  //       isAcura = false
  //     } else {
  //       isAcura = true
  //     }
  //   }
  //   this.dialog.open(RemoveVehicleComponent, {
  //     data: { planDuration: this.selectedSP ? this.getPlanDuration(this.selectedSP?.clientAltRateScheduleId) : "", isAcura },
  //     // height: '70vh',
  //     width: '60vw',
  //   });
  // }

  getPlanDuration(clientAltRateScheduleId: string | null | undefined) {
    if (!clientAltRateScheduleId) return null;
    let arrayRateSchedule = clientAltRateScheduleId.split('_');
    if (arrayRateSchedule) {
      let arrLen = arrayRateSchedule?.length;
      if (arrLen) {
        if (arrLen > 2 && arrayRateSchedule[arrLen - 1] == 'Trial') {
          return this.titleCaseWord(arrayRateSchedule[arrLen - 1].toLowerCase())
        } else {
          let duration = this.titleCaseWord(arrayRateSchedule[arrLen - 1].toLowerCase());
          if (duration == "3year") { return "3 Year" }
          else if (duration == "5year") { return "5 Year" }
        }
      }
    }
    return null;
  }

  titleCaseWord(word: string) {
    if (!word) return word;
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }

  getVehicleDetails() {
    this.appService.MyVehicle().subscribe((res) => {
      if (res && res.status == 'SUCCESS') {
        let vehicleInfo = res.vehicleInfo;
        if (vehicleInfo && vehicleInfo.length > 0) {
          this.licensePlateNo = vehicleInfo[0].licensePlate
            ? vehicleInfo[0].licensePlate
            : vehicleInfo[0].LicensePlateNo;
          this.vehicleMake = vehicleInfo[0].DivisionName;
        }
      }
      
      
    });
  }
}
